import React, { useState, useEffect } from "react";
import { getTimeUntilReset } from "../utils/dailyUsageManager";

/**
 * Modal hiển thị khi user đã hết lượt sử dụng trong ngày
 */
const UsageLimitModal = ({ onClose, usedCount, limit }) => {
  const [countdown, setCountdown] = useState({
    hours: 0,
    minutes: 0,
    seconds: 0,
    formattedTime: "0 giờ 0 phút",
  });

  // Update countdown mỗi giây
  useEffect(() => {
    const updateCountdown = () => {
      const timeData = getTimeUntilReset();
      setCountdown(timeData);
    };

    // Update ngay lập tức
    updateCountdown();

    // Update mỗi giây
    const interval = setInterval(updateCountdown, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.6)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
        padding: "20px",
      }}
      onClick={onClose}
    >
      <div
        style={{
          backgroundColor: "white",
          borderRadius: "16px",
          maxWidth: "500px",
          width: "100%",
          padding: "32px",
          boxShadow: "0 20px 60px rgba(0, 0, 0, 0.3)",
          textAlign: "center",
          position: "relative",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close button */}
        <button
          onClick={onClose}
          style={{
            position: "absolute",
            top: "16px",
            right: "16px",
            background: "transparent",
            border: "none",
            fontSize: "24px",
            color: "#999",
            cursor: "pointer",
            padding: "4px 8px",
            lineHeight: "1",
          }}
          onMouseEnter={(e) => (e.target.style.color = "#333")}
          onMouseLeave={(e) => (e.target.style.color = "#999")}
        >
          ×
        </button>

        {/* Icon */}
        <div
          style={{
            fontSize: "64px",
            marginBottom: "16px",
          }}
        >
          ⏰
        </div>

        {/* Title */}
        <h2
          style={{
            fontSize: "24px",
            fontWeight: "bold",
            color: "#333",
            marginBottom: "12px",
          }}
        >
          Bạn đã hết lượt sử dụng hôm nay
        </h2>

        {/* Message */}
        <p
          style={{
            fontSize: "16px",
            color: "#666",
            marginBottom: "24px",
            lineHeight: "1.5",
          }}
        >
          Bạn đã sử dụng <strong>{usedCount}/{limit} lượt</strong> định giá trong ngày hôm nay.
        </p>

        {/* Countdown */}
        <div
          style={{
            backgroundColor: "#f0f9ff",
            borderRadius: "12px",
            padding: "20px",
            marginBottom: "24px",
          }}
        >
          <div
            style={{
              fontSize: "14px",
              color: "#0ea5e9",
              marginBottom: "8px",
              fontWeight: "500",
            }}
          >
            Số lượt sẽ được reset sau:
          </div>
          <div
            style={{
              fontSize: "32px",
              fontWeight: "bold",
              color: "#0284c7",
              fontFamily: "monospace",
            }}
          >
            {countdown.hours.toString().padStart(2, "0")}:
            {countdown.minutes.toString().padStart(2, "0")}:
            {countdown.seconds.toString().padStart(2, "0")}
          </div>
          <div
            style={{
              fontSize: "12px",
              color: "#64748b",
              marginTop: "4px",
            }}
          >
            ({countdown.formattedTime})
          </div>
        </div>

        {/* Description */}
        <p
          style={{
            fontSize: "14px",
            color: "#888",
            marginBottom: "24px",
            lineHeight: "1.6",
          }}
        >
          📊 Dữ liệu của bạn giúp chúng tôi cải thiện dịch vụ và mang lại trải nghiệm tốt hơn cho
          tất cả người dùng.
        </p>

        {/* CTA Button */}
        <button
          onClick={onClose}
          style={{
            backgroundColor: "#0ea5e9",
            color: "white",
            border: "none",
            borderRadius: "8px",
            padding: "12px 32px",
            fontSize: "16px",
            fontWeight: "500",
            cursor: "pointer",
            transition: "all 0.2s",
            width: "100%",
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = "#0284c7";
            e.target.style.transform = "translateY(-2px)";
            e.target.style.boxShadow = "0 4px 12px rgba(14, 165, 233, 0.4)";
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = "#0ea5e9";
            e.target.style.transform = "translateY(0)";
            e.target.style.boxShadow = "none";
          }}
        >
          Đã hiểu
        </button>

        {/* Additional info */}
        <p
          style={{
            fontSize: "12px",
            color: "#aaa",
            marginTop: "16px",
            lineHeight: "1.4",
          }}
        >
          💡 Tip: Mỗi ngày bạn sẽ có {limit} lượt định giá miễn phí. Hãy quay lại vào ngày mai để
          tiếp tục sử dụng dịch vụ!
        </p>
      </div>
    </div>
  );
};

export default UsageLimitModal;
